<template>
    <div class="login-full-a" id="category">
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name">
                        {{question}}
                    </div>
                    <button class="pull-right btn btn-info deleteMedia mr-1 " type="button" v-on:click.prevent="backButton()">Back</button>
                </div>
                <!--page content-->
                <div class="admin-page-content">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-12 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label"> Comment : {{comment}}</div>
                                </div>
                            </div>
                        </div>
                        <button title='Delete Comment' id="delete" class="btn btn-danger"  v-on:click.prevent="deleteComment()">Delete</button>
                    </div>
                </div>
                <!--page content-->
            </div>
            <app-backend-footer></app-backend-footer>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import BackendFooter from '@/components/backend/partials/Footer';
    import {bTabs} from 'bootstrap-vue/es/components/tabs/tabs';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'ViewQuestionOfForumComment',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                commentId: 0,
                question: "",
                comment: '',
            }
        },
        computed: {
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/")[3];
            self.commentId = segments;

            self.MenuClose();
            self.getCommentQuestion();
        },

        methods: {
            backButton: function () {
                var route = '/backend/forum-comments';
                /* if (self.commentId > 0) {
                    route += '/' + self.commentId;
                } */
                self.$router.push(route);
            },
            deleteComment: function () {
                var questionArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                let id = self.commentId;
                if (id) {
                    questionArr.push(id);
                }
                var fields = {
                    deleteArr: questionArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deletecomments", fields, config)
                                .then(function (response) {
                                    self.backButton();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                })
            },
            getCommentQuestion() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    comment_id: self.commentId,
                };
                HTTP.post("getcommentquestion", fields, config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                self.question = response.data.content.question;
                                self.comment = response.data.content.comment;
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                if (err.response.data.code == 400) {
                                    self.backButton();
                                }
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/backend/forum/ViewQuestionOfForumComment.vue